import posthog from "posthog-js";

const posthogProjectToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;

if (posthogProjectToken) {
  posthog.init(posthogProjectToken, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "/cb4ba675ac41",
    ui_host: "https://eu.posthog.com",
    defaults: "2026-01-30",
    capture_pageview: "history_change",
    debug: process.env.NODE_ENV === "development",
  });
}
